import Field from './containers/Field.component';

export default Field;